import { atom, useAtomValue, useSetAtom } from 'jotai';
import { ConfigResponse } from 'services/api/flagr';
import AppConfig from 'services/config/app';

const flagConfigAtom = atom<ConfigResponse>(AppConfig.value);
export const flagConfigState = atom(
  (get) => get(flagConfigAtom),
  (_, set, next: ConfigResponse) => {
    set(flagConfigAtom, next);
    AppConfig.value = next;
  },
);

export const useFlagConfigValue = () => {
  return useAtomValue(flagConfigState);
};

export const useSetFlagConfigValue = () => {
  return useSetAtom(flagConfigState);
};
